import { api } from '@/scripts/api';

export const DocumentTemplateService = {

    get(id, config = {}) {
        return new Promise((resolve, reject) => {

            const service = '/service/DocumentTemplates';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    getAll(config = {}, signal) {
        return new Promise((resolve, reject) => {
            const service = '/service/DocumentTemplates';
            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint, signal)
                .then(resolve)
                .catch((error)=>{
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                })
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/DocumentTemplates', payload)
                .then(resolve)
                .catch(reject);
        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/DocumentTemplates/${ id }`;

            api.patch(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/DocumentTemplates/${ id }`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },

    duplicate(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/DocumentTemplates/${ id }/Duplicate`;

            api
                .post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    publish(id, clientIds) {

        return new Promise((resolve, reject) => {
            const service = `/api/DocumentTemplates/${ id }/Publish`;

            api
                .post(service, clientIds)
                .then(resolve)
                .catch(reject);
        });

    },

    unpublish(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/DocumentTemplates/${ id }/Publish`;

            api
                .post(service, [])
                .then(resolve)
                .catch(reject);
        });
    },

    getSharedAssets(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/SharedAssets';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `DocumentTemplateId eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClient(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    addToMyDocumentTemplates(accountId, id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Accounts/${accountId}/DocumentTemplates/${id}/Add`;

            api
                .post(service)
                .then(resolve)
                .catch(reject)
        })
    }
}